import * as T from './HeadlineTooltipButton.types';
import Button from '@media-ui/core/src/components/Button';
import { FunctionComponent } from 'react';
import * as s from './HeadlineTooltipButton.css';
const HeadlineTooltipButton: FunctionComponent<T.IHeadlineTooltipButton> = (props) => {
    const { children } = props;
    return (<Button dataQaDetail="HeadlineTooltipButton" iconOnly className={s.root}>
      {children}
    </Button>);
};
export default HeadlineTooltipButton;
